import { FILTERS_SET_DEAL_TYPE_TYPE, FAVORITE_ENTITIES_GET_FAVORITE_ENTITIES_TYPE } from '../../constants/actionTypes';
import { EDealType } from '../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { TReduxActions } from '../../types/redux';
import { EGetFavoriteEntitiesStatus } from '../../types/results';

const defaultDealType: EDealType | null = null;

export function dealTypeReducer(state: EDealType | null = defaultDealType, action: TReduxActions) {
  switch (action.type) {
    case FILTERS_SET_DEAL_TYPE_TYPE:
      return action.dealType;

    case FAVORITE_ENTITIES_GET_FAVORITE_ENTITIES_TYPE:
      return action.status === EGetFavoriteEntitiesStatus.Failed ? action.prevFilters.dealType : state;
  }

  return state;
}
